import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { classNames } from '../../helpers'
import Button from '../button'

const TRANSLATION_LOCATION = 'components.settings.settings_container.'

const SettingsContainer = ({
  title,
  description,
  onSubmit,
  actions,
  dirty,
  isLoading,
  hideDescription,
  className,
  children
}) => {
  const { t } = useTranslation()

  return (
    <div className={className}>
      {!hideDescription && (
        <>
          <h1 className='text-xl font-semibold text-gray-900'>{title}</h1>
          <p className='mt-1 max-w-lg text-sm text-gray-700 lg:max-w-2xl'>
            {description}
          </p>
        </>
      )}
      <div className={!hideDescription ? 'mt-5' : ''}>
        <div className='relative bg-gray-50 sm:rounded-md'>
          <div
            className={classNames(
              'space-y-6 px-4 py-5 sm:rounded-t-md sm:p-6',
              !onSubmit && 'sm:rounded-b-md'
            )}
          >
            {children}
          </div>
          {actions && (
            <div
              className={classNames(
                'flex justify-end gap-x-2',
                'bg-gray-100 px-4 py-3 sm:rounded-b-md sm:px-6'
              )}
            >
              {actions}
            </div>
          )}
          {onSubmit && (
            <div className='bg-gray-100 px-4 py-3 text-right sm:rounded-b-md sm:px-6'>
              <Button
                appearance='save'
                text={t(TRANSLATION_LOCATION + 'on_submit_action')}
                onClick={onSubmit}
                disabled={!dirty}
                isLoading={isLoading}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

SettingsContainer.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onSubmit: PropTypes.func,
  actions: PropTypes.node,
  dirty: PropTypes.bool,
  isLoading: PropTypes.bool,
  hideDescription: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

SettingsContainer.defaultProps = {
  title: 'Lorem Ipsum',
  description: '',
  onSubmit: undefined,
  actions: undefined,
  dirty: false,
  isLoading: false,
  hideDescription: false,
  className: ''
}

export default SettingsContainer
